module.exports = __webpack_public_path__ + "static/il-translation-0b9072c0dc47c2c259f3d9d259867452.svg";